// Tạo snapshot backup trước khi uninstall. Folder: ~/.avatar/uninstall-backups/
// <project-name>-<ts>/ với cấu trúc trong spec doc.
import { cp, mkdir, writeFile } from "node:fs/promises";
import { homedir } from "node:os";
import { basename, join } from "node:path";
import type { AvatarProjectArtifacts } from "./detect-avatar-project-artifacts.js";

export interface BackupManifest {
  projectName: string;
  projectPath: string;
  timestamp: string;
  avatarVersion: string;
  artifacts: {
    claudeDir: boolean;
    claudeMd: boolean;
    postMergeHook: boolean;
    prePushHook: boolean;
  };
}

const UNINSTALL_BACKUPS_DIR = join(homedir(), ".avatar", "uninstall-backups");

export async function createUninstallBackupSnapshot(
  projectRoot: string,
  artifacts: AvatarProjectArtifacts,
  avatarVersion: string,
): Promise<string> {
  const projectName = basename(projectRoot);
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  const backupDir = join(UNINSTALL_BACKUPS_DIR, `${projectName}-${timestamp}`);

  await mkdir(backupDir, { recursive: true, mode: 0o700 });

  // Copy .claude/ và CLAUDE.md nếu tồn tại.
  if (artifacts.claudeDir) {
    await cp(artifacts.claudeDir, join(backupDir, ".claude"), { recursive: true });
  }
  if (artifacts.claudeMd) {
    await cp(artifacts.claudeMd, join(backupDir, "CLAUDE.md"));
  }

  // Copy hooks sang backup/hooks/.
  if (artifacts.postMergeHook || artifacts.prePushHook) {
    const hooksBackupDir = join(backupDir, "hooks");
    await mkdir(hooksBackupDir, { recursive: true });
    if (artifacts.postMergeHook) {
      await cp(artifacts.postMergeHook, join(hooksBackupDir, "post-merge"));
    }
    if (artifacts.prePushHook) {
      await cp(artifacts.prePushHook, join(hooksBackupDir, "pre-push"));
    }
  }

  // Write manifest.
  const manifest: BackupManifest = {
    projectName,
    projectPath: projectRoot,
    timestamp,
    avatarVersion,
    artifacts: {
      claudeDir: !!artifacts.claudeDir,
      claudeMd: !!artifacts.claudeMd,
      postMergeHook: !!artifacts.postMergeHook,
      prePushHook: !!artifacts.prePushHook,
    },
  };
  await writeFile(join(backupDir, "manifest.json"), JSON.stringify(manifest, null, 2), "utf8");

  return backupDir;
}
